import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// Deve ser importado antes do App: inicializa o i18n e normaliza o idioma
// salvo no localStorage antes de qualquer módulo que o leia.
import './translate/i18n';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { Provider } from 'react-redux';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ptBR } from '@mui/x-date-pickers';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ReduxToastr from 'react-redux-toastr';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ptbr from 'date-fns/locale/pt-BR';

import store from './store/store';
import ReactGA from 'react-ga';
import { GOOGLE_ANALYTICS_TRACKING_ID } from './axios/api';

const ptText = ptBR.components.MuiLocalizationProvider.defaultProps.localeText;

if (process.env.REACT_APP_ENV === 'prod') {
  ReactGA.initialize(GOOGLE_ANALYTICS_TRACKING_ID);
}

ReactDOM.render(
  <HelmetProvider>
  <BrowserRouter>
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptbr} localeText={ptText} >
      <Provider store={store}>
        <App />
        <ReduxToastr
          timeOut={5000}
          newestOnTop={false}
          preventDuplicates
          position="top-right"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar
          closeOnToastrClick={false}
          showCloseButton />
      </Provider>
    </LocalizationProvider>
  </BrowserRouter>
  </HelmetProvider>,
  document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
